import React, { useEffect, useState } from "react";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { imgBaseUrl } from "../../api/api";
import { settingUpdate } from "../../api/Setting";
import { districtsList, statesList } from "../../api/Locations";
import "react-quill/dist/quill.bubble.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import SettingLayout from "./SettingLayout";

export default function Settings() {
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [data, setData] = useState({});
  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ size: ["small", false, "large", "huge"] }],

      ["bold", "italic", "underline", "strike"],

      [{ color: [] }, { background: [] }],

      [{ script: "sub" }, { script: "super" }],

      [{ header: 1 }, { header: 2 }, "blockquote", "code-block"],

      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],

      [{ align: [] }],

      ["link", "image", "video"],

      ["clean"],
    ],
  };

  useEffect(() => {
    setData(JSON.parse(localStorage.getItem("setting") ?? {}));
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUpdateData = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await settingUpdate(formData);
      if (response.data.status === true) {
        localStorage.setItem("setting", JSON.stringify(response.data.data));
        setPreview(false);
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getStates = async () => {
    setLoading(true);
    try {
      const response = await statesList();
      if (response.data.status === true) {
        setStates(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getDistricts = async (state = null) => {
    setLoading(true);
    try {
      let addUrl = "";
      if (state) addUrl += `&state=${state}`;
      const response = await districtsList(addUrl);
      if (response.data.status === true) {
        setDistricts(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStates();
    getDistricts();
  }, []);
  useEffect(() => {
    if (data?.state) {
      getDistricts(data?.state);
    }
  }, [data?.state]);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <SettingLayout />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <form className="row g-4" onSubmit={handleUpdateData}>
                          <div className="col-sm-3">
                            <img
                              src={imgBaseUrl + data?.logo_img}
                              alt="LOGO"
                              className="w-100"
                            />
                          </div>
                          <div className="col-sm-5 d-flex gap-3">
                            <div className="">
                              <label
                                htmlFor="logo_img"
                                className="btn btn-primary btn-sm"
                              >
                                <i className="ri-upload-2-line me-2" /> Update
                                Logo
                                <input
                                  type="file"
                                  id="logo_img"
                                  name="logo_img"
                                  hidden
                                  accept="image/*"
                                  capture="environment"
                                  onChange={handleFileChange}
                                />
                              </label>
                            </div>
                            {preview && (
                              <div className="">
                                <img
                                  src={preview}
                                  alt="Logo Preview"
                                  className="rounded-3"
                                  style={{
                                    maxWidth: "100px",
                                    maxHeight: "100px",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                          {data?.biometric_company_code && (
                            <div className="col-sm-4 text-end">
                              <h5 className="text-primary">
                                Biometric School Code :{" "}
                                {data?.biometric_company_code}
                              </h5>
                            </div>
                          )}
                          <div className="col-sm-12">
                            <h5 className="m-0 text-primary">
                              School/Institute Details
                            </h5>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-floating form-floating-outline">
                              <input
                                className="form-control input-uppercase"
                                type="text"
                                id="name"
                                name="name"
                                defaultValue={data?.name}
                              />
                              <label htmlFor="name">
                                School/Institute Name
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-floating form-floating-outline">
                              <textarea
                                className="form-control"
                                type="text"
                                id="tag_line"
                                name="tag_line"
                                defaultValue={data?.tag_line}
                              />
                              <label htmlFor="tag_line">Tag Line</label>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                id="mobile"
                                name="mobile"
                                defaultValue={data?.mobile}
                              />
                              <label htmlFor="mobile">Mobile No</label>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                id="secondary_mobile"
                                name="secondary_mobile"
                                defaultValue={data?.secondary_mobile}
                              />
                              <label htmlFor="secondary_mobile">
                                Secondary Mobile No
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-floating form-floating-outline">
                              <input
                                className="form-control"
                                type="email"
                                id="email"
                                name="email"
                                defaultValue={data?.email}
                              />
                              <label htmlFor="email">Email</label>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-floating form-floating-outline">
                              <textarea
                                className="form-control input-uppercase"
                                type="text"
                                id="village"
                                name="village"
                                defaultValue={data?.village}
                              />
                              <label htmlFor="village">Village/Town</label>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-floating form-floating-outline">
                              <select
                                name="state"
                                id="state"
                                className="form-select"
                                value={data?.state}
                                onChange={(e) =>
                                  setData({
                                    ...data,
                                    state: e.target.value,
                                  })
                                }
                              >
                                <option value="" selected disabled>
                                  Select State
                                </option>
                                {states?.map((state, i) => (
                                  <option key={i} value={state.name}>
                                    {state.name}
                                  </option>
                                ))}
                              </select>

                              <label htmlFor="state">Select State</label>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-floating form-floating-outline">
                              <select
                                name="district"
                                id="district"
                                className="form-select"
                                value={data?.district}
                                onChange={(e) =>
                                  setData({
                                    ...data,
                                    district: e.target.value,
                                  })
                                }
                              >
                                <option value="" selected disabled>
                                  Select District
                                </option>
                                {districts?.map((district, i) => (
                                  <option value={district.name}>
                                    {district.name}
                                  </option>
                                ))}
                              </select>

                              <label htmlFor="district">Select District</label>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-floating form-floating-outline">
                              <input
                                className="form-control"
                                type="number"
                                id="pin_code"
                                name="pin_code"
                                defaultValue={data?.pin_code}
                              />
                              <label htmlFor="pin_code">Pin Code</label>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-floating form-floating-outline">
                              <input
                                className="form-control"
                                type="file"
                                id="signature"
                                name="signature"
                                defaultValue={data?.signature}
                              />
                              <label htmlFor="signature">Signature</label>
                            </div>
                          </div>
                          <div className="col-sm-2">
                            {data?.signature && (
                              <img
                                src={imgBaseUrl + data?.signature}
                                alt="signature"
                                className="w-100"
                              />
                            )}
                          </div>
                          <div className="col-sm-6">
                            <div className="form-floating form-floating-outline">
                              <input
                                className="form-control"
                                type="text"
                                id="registration_no"
                                name="registration_no"
                                defaultValue={data?.registration_no}
                              />
                              <label htmlFor="registration_no">
                                School/Institute Resignation No
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-floating form-floating-outline">
                              <select
                                name="gst_status"
                                id="gst_status"
                                className="form-select"
                                value={data?.gst_status || ""}
                                onChange={(e) =>
                                  setData({
                                    ...data,
                                    gst_status: e.target.value,
                                  })
                                }
                              >
                                <option value="" disabled>
                                  Select GST Status
                                </option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>

                              <label htmlFor="gst_status">GST Status</label>
                            </div>
                          </div>
                          {data?.gst_status === "Yes" && (
                            <div className="col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  className="form-control"
                                  type="text"
                                  id="gst_no"
                                  name="gst_no"
                                  defaultValue={data?.gst_no}
                                />

                                <label htmlFor="gst_no">GST No</label>
                              </div>
                            </div>
                          )}
                          <div className="col-sm-12">
                            <hr />
                            <h5 className="m-0 text-primary">Social Media</h5>
                          </div>

                          <div className="col-sm-6">
                            <div className="form-floating form-floating-outline">
                              <input
                                className="form-control"
                                type="text"
                                id="instagram"
                                name="instagram"
                                defaultValue={data?.instagram}
                              />

                              <label htmlFor="instagram">Instagram Link</label>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-floating form-floating-outline">
                              <input
                                className="form-control"
                                type="text"
                                id="facebook"
                                name="facebook"
                                defaultValue={data?.facebook}
                              />

                              <label htmlFor="facebook">Facebook Link</label>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-floating form-floating-outline">
                              <input
                                className="form-control"
                                type="text"
                                id="youtube"
                                name="youtube"
                                defaultValue={data?.youtube}
                              />

                              <label htmlFor="youtube">Youtube Link</label>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-floating form-floating-outline">
                              <input
                                className="form-control input-lowercase"
                                type="text"
                                id="website"
                                name="website"
                                defaultValue={data?.website}
                              />

                              <label htmlFor="website">Website Link</label>
                            </div>
                          </div>

                          <div className="col-sm-12">
                            <hr />
                            <h5 className="m-0 text-primary">
                              Terms & Conditions ( Admission form )
                            </h5>

                            <ReactQuill
                              theme="snow"
                              value={
                                data?.admission_form_terms_conditions || ""
                              }
                              modules={modules}
                              onChange={(value) =>
                                setData({
                                  ...data,
                                  admission_form_terms_conditions: value,
                                })
                              }
                            />

                            <input
                              type="hidden"
                              name="admission_form_terms_conditions"
                              value={
                                data?.admission_form_terms_conditions || ""
                              }
                            />
                          </div>

                          <div className="col-sm-12 text-end">
                            <button type="submit" className="btn btn-primary ">
                              Save changes
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
